
export const CATEGORIES_ACTION_TYPES = {

    FETCH_CATEGORIES_PREVIEW_START: "FETCH_CATEGORIES_PREVIEW_START",
    FETCH_CATEGORIES_PREVIEW_FAILED: "FETCH_CATEGORIES_PREVIEW_FAILED",
    FETCH_CATEGORIES_PREVIEW_SUCCESS: "FETCH_CATEGORIES_PREVIEW_SUCCESS",


    FETCH_CATEGORY_PRODUCTS_START: "FETCH_CATEGORY_PRODUCTS_START",
    FETCH_CATEGORY_PRODUCTS_FAILED: "FETCH_CATEGORY_PRODUCTS_FAILED",
    FETCH_CATEGORY_PRODUCTS_SUCCESS: "FETCH_CATEGORY_PRODUCTS_SUCCESS",

    FETCH_SEARCH_RESULT: "FETCH_SEARCH_RESULT",
}